import { HStack, VStack, Box } from "@chakra-ui/react";
import CDS from "design-system";

function LegendItem({ color, label, dashed }: { color: string; label: string; dashed?: boolean }) {
  return (
    <VStack spacing={0}>
      <Box
        w="12px"
        h="12px"
        bg={color}
        borderRadius="sm"
        borderWidth={dashed ? "1px" : undefined}
        borderStyle={dashed ? "dashed" : undefined}
        borderColor={dashed ? "green.400" : undefined}
      />
      <CDS.Text10 fontSize="2xs" color="gray.600" textAlign="center">
        {label}
      </CDS.Text10>
    </VStack>
  );
}

export default function Legend() {
  return (
    <HStack spacing={4} px={2} py={1} justify="center">
      <LegendItem color="red.400" label="GCal event" />
      <LegendItem color="orange.400" label="Camino" />
      <LegendItem color="blue.300" label="Reservation" />
      <LegendItem color="purple.300" label="Current" />
      <LegendItem color="gray.100" label="Off hours" />
      <LegendItem color="green.50" label="Suggested" dashed />
      <LegendItem color="blue.100" label="Selected" />
    </HStack>
  );
}
